import superagent from 'superagent'

const fetchPrivateLandGetFilterValuesAction = payload => ({
  type: 'PRIVATE_LAND_GET_FILTER_VALUES',
  payload: payload
})

export const fetchPrivateLandsItemsAction = payload => ({
  type: 'PRIVATE_LAND_GET_ITEMS',
  payload: payload
})

export const privateLandPayloadAction = payload => ({
  type: 'PRIVATE_LAND_PAYLOAD',
  payload: payload
})

export const privateLandPayloadRemoveAction = () => ({
  type: 'PRIVATE_LAND_PAYLOAD_REMOVE',
})

export const fetchPrivateLandGetFilterValues = () => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/PrivateLand/GetFilterValues`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return resolve(err.status)
        }
        dispatch(fetchPrivateLandGetFilterValuesAction(res.body))
      })
  })
}


export const fetchPrivateLandItems = (payload) => (dispatch, getState, token) => {

  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });

  const params = new URLSearchParams(payload).toString();


  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/PrivateLand/Get/?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return resolve(err.status)
        }
        dispatch(fetchPrivateLandsItemsAction(res.body))
        resolve(res.body)
      })
  })
}


export const fetchPrivateLandGetListing = (payload, cb) => (dispatch, getState, token) => {
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });

  const params = new URLSearchParams(payload).toString();

  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/PrivateLand/GetListing/?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return reject(err.status)
        }
        cb(res.body)
        resolve(res.body)
      })
  })
}
